module.exports = __webpack_public_path__ + "img/landing_page_1.54861827.png";